<template>
  <div>
    <page-title title="Criar"/>
    <panel title="Token">
      <form-group label="Nome" :columns="4">
        <input class="form-input" type="text" v-model="tokenName">
      </form-group>
    </panel>

    <panel title="Permissões de produto">
      <div class="l-row">
        <form-group label="" :columns="12">
          <select v-model="permissionProductSelected" class="form-select" @change="getPermissionProduct()">
            <option value="notPermission">Sem permissão</option>
            <option value="readOnly">Somente leitura</option>
            <option value="readAndWriting">Leitura e escrita</option>
            <option value="advancedOptionsProduct">Opções avançadas</option>
          </select>
        </form-group>
      </div>

      <div class="l-row" v-if="permissionProductSelected === 'advancedOptionsProduct'">
        <div class="l-col-12@md">
          <form-group :label="option.resource" :columns="4" v-for="option in productAdvancedOptions" :key="option">
            <label class="form-checkbox" v-for="action in Object.keys(option.actions)">
              <input v-model="option.actions[action]" type="checkbox">
              <span class="form-checkbox__indicator"></span>
              <span class="form-checkbox__text">{{ action }}</span>
            </label>
          </form-group>
        </div>
      </div>
    </panel>

    <panel title="Permissões de pedido">
      <div class="l-row">
        <form-group label="" :columns="12">
          <select v-model="permissionOrderSelected" class="form-select" @change="getPermissionOrder()">
            <option value="notPermission">Sem permissão</option>
            <option value="readOnly">Somente leitura</option>
            <option value="readAndWriting">Leitura e escrita</option>
            <option value="advancedOptionsOrder">Opções avançadas</option>
          </select>
        </form-group>
      </div>

      <div class="l-row" v-if="permissionOrderSelected === 'advancedOptionsOrder'">
        <div class="l-col-12@md">
          <form-group :label="option.resource" :columns="4" v-for="option in orderAdvancedOptions" :key="option">
            <label class="form-checkbox" v-for="action in Object.keys(option.actions)">
              <input v-model="option.actions[action]" type="checkbox">
              <span class="form-checkbox__indicator"></span>
              <span class="form-checkbox__text">{{ action }}</span>
            </label>
          </form-group>
        </div>
      </div>
    </panel>

    <panel>
      <button :disabled="saving" @click="save()" v-bind:class="{ 'is-loading': saving }" class="btn btn--success" type="submit">Criar</button>
    </panel>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'
  import PageTitle from '@/components/template/PageTitle'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import { cloneDeep, concat } from 'lodash'
  import { productSimpleOptions, orderSimpleOptions, productAdvancedOptions, orderAdvancedOptions } from '@/storage/tokenPermissions'

  export default {
    data: () => ({
      tokenName: null,
      saving: false,
      permissionProductSelected: 'notPermission',
      permissionOrderSelected: 'notPermission',
      productSimpleOptions: null,
      orderSimpleOptions: null,
      productAdvancedOptions: [],
      orderAdvancedOptions: []
    }),
    mounted () {
      this.productSimpleOptions = cloneDeep(productSimpleOptions)
      this.orderSimpleOptions = cloneDeep(orderSimpleOptions)
      this.productAdvancedOptions = cloneDeep(productAdvancedOptions)
      this.orderAdvancedOptions = cloneDeep(orderAdvancedOptions)
    },
    methods: {
      save () {
        this.saving = true

        let token = {}

        if (this.tokenName) {
          token.description = this.tokenName
        }

        token.permissions = concat(this.getPermissionProduct(), this.getPermissionOrder())

        api.saveToken(token)
          .then(() => {
            notifier.success('Token cadastrado com sucesso!', 'Sucesso')
            this.saving = false
            this.$router.push('/tool/api/tokens')
          })
          .catch(() => notifier.error('Erro ao cadastrar token.', 'Erro'))
      },
      getPermissionProduct () {
        if (this.permissionProductSelected === 'notPermission') {
          return []
        }

        if (this.permissionProductSelected === 'advancedOptionsProduct') {
          return this.productAdvancedOptions.map(advancedOption => {
            const actions = []

            for (let i in Object.keys(advancedOption.actions)) {
              const method = Object.keys(advancedOption.actions)[i]

              if (advancedOption.actions[method]) {
                actions.push(method)
              }
            }

            return {
              resource: advancedOption.resource,
              actions: actions
            }
          })
            .filter(permission => permission.actions.length)
        }

        return this.productSimpleOptions[this.permissionProductSelected]
      },
      getPermissionOrder () {
        if (this.permissionOrderSelected === 'notPermission') {
          return []
        }

        if (this.permissionOrderSelected === 'advancedOptionsOrder') {
          return this.orderAdvancedOptions.map(advancedOption => {
            const actions = []

            for (let i in Object.keys(advancedOption.actions)) {
              const method = Object.keys(advancedOption.actions)[i]

              if (advancedOption.actions[method]) {
                actions.push(method)
              }
            }

            return {
              resource: advancedOption.resource,
              actions: actions
            }
          })
            .filter(permission => permission.actions.length)
        }

        return this.orderSimpleOptions[this.permissionOrderSelected]
      }
    },
    components: {
      PageTitle,
      Panel,
      FormGroup
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Create.vue?cea15184